class TsProduct extends HTMLElement {
  constructor() {
    super();
    this.galleryThumbs = null;
    this.galleryTop = null;
    this._inited = false;
  }

  connectedCallback() {
    // уникаємо подвійної ініціалізації
    if (this._inited) return;
    this._inited = true;

    // чекаємо, поки Swiper буде доступний
    if (typeof Swiper === 'undefined') {
      // спроба ініціалізації пізніше
      setTimeout(() => this.init(), 50);
    } else {
      this.init();
    }
  }

  init() {
    this.initSlider();
    this.bindLightbox();
  }

  initSlider() {
    const wrapper = this; // <ts-product>
    const galleryEl = wrapper.querySelector('.ts-gallery');
    const thumbsEl  = wrapper.querySelector('.ts-gallery-thumbs');

    if (!galleryEl) return;

    // кількість слайдів у головній галереї
    const slideEls = galleryEl.querySelectorAll('.swiper-wrapper .swiper-slide');
    const slidesCount = slideEls.length;

    // ініціалізуємо мініатюри, якщо є контейнер
    if (thumbsEl && typeof Swiper !== 'undefined') {
      this.galleryThumbs = new Swiper(thumbsEl, {
        spaceBetween: 8,
        slidesPerView: 3,
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        breakpoints: {
          744: { direction: 'vertical', spaceBetween: 16 },
          1024:{ direction: 'vertical', slidesPerView: 4, spaceBetween: 16 }
        }
      });
    }

    // стрілки, якщо є >1 фото
    const prevEl = galleryEl.querySelector('.swiper-button-prev');
    const nextEl = galleryEl.querySelector('.swiper-button-next');
    const hasMany = slidesCount > 1;

    if (typeof Swiper !== 'undefined') {
      this.galleryTop = new Swiper(galleryEl, {
        spaceBetween: 10,
        autoHeight: true,
        loop: false,
        watchOverflow: false, // не ховати навігацію автоматично
        navigation: hasMany && prevEl && nextEl ? { prevEl, nextEl } : false,
        thumbs: this.galleryThumbs ? { swiper: this.galleryThumbs } : undefined,
        on: {
          init() {
            // вручну показати/сховати стрілки
            [prevEl, nextEl].forEach(btn => {
              if (!btn) return;
              btn.style.display = hasMany ? 'flex' : 'none';
            });
          }
        }
      });

      // оновлення після можливого lazy-load
      setTimeout(() => this.galleryTop && this.galleryTop.update(), 0);
    }
  }

  bindLightbox() {
    const wrapper = this;
    const images = wrapper.querySelectorAll('.swiper-image');
    if (!images.length) return;

    const lightbox = document.querySelector('.custom-lightbox');
    const closeBtn = lightbox ? lightbox.querySelector('.lightbox-close') : null;
    let lightboxSwiper = null;

    const openLightbox = (startIndex = 0) => {
      if (!lightbox) return;
      lightbox.style.display = 'flex';

      // знищуємо попередній інстанс, якщо був
      if (lightboxSwiper && typeof lightboxSwiper.destroy === 'function') {
        lightboxSwiper.destroy(true, true);
        lightboxSwiper = null;
      }

      if (typeof Swiper === 'undefined') return;

      lightboxSwiper = new Swiper('.swiper-container-lightbox', {
        slidesPerView: 1,
        spaceBetween: 8,
        initialSlide: Number(startIndex) || 0,
        pagination: {
          el: '.custom-lightbox .swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.custom-lightbox .swiper-button-next',
          prevEl: '.custom-lightbox .swiper-button-prev'
        },
        zoom: {
          maxRatio: 2.5,
          minRatio: 1
        }
      });
    };

    const closeLightbox = () => {
      if (!lightbox) return;
      lightbox.style.display = 'none';
      if (lightboxSwiper && typeof lightboxSwiper.destroy === 'function') {
        lightboxSwiper.destroy(true, true);
        lightboxSwiper = null;
      }
    };

    // відкриття по кліку на картинку
    images.forEach(img => {
      img.addEventListener('click', e => {
        const index = e.currentTarget.getAttribute('data-index') || 0;
        openLightbox(index);
      });
    });

    // закриття по кнопці
    closeBtn && closeBtn.addEventListener('click', closeLightbox);

    // закриття по кліку поза контентом
    lightbox && lightbox.addEventListener('click', e => {
      if (e.target === e.currentTarget) closeLightbox();
    });
  }
}

customElements.define('ts-product', TsProduct);